<template>
  <span>
    <svg
      v-if="small"
      width="60"
      height="90"
      viewBox="0 0 60 90"
      style="font-family: sans-serif; font-size: 10px;"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <text
        x="23"
        y="14"
        text-anchor="middle"
        :style="'font-size: 14px; fill: ' + fillColor"
      >
        {{ chord }}
      </text>
      <g :transform="return_diagram_position_small()">
        <text id="position" x="42" y="12" text-anchor="left">
          {{ position }}
        </text>
        <rect
          v-if="position == 0"
          id="nut"
          height="4"
          width="37"
          :fill="fillColor"
        />
        <g id="diamond" style="visibility:hidden;">
          <rect width="9" height="9" transform="translate(0,-10),rotate(45)" />
        </g>
        <g id="strings" transform="translate(0,2)">
          <rect height="48" width="1" x="0" :fill="fillColor" />
          <rect height="48" width="1" x="12" :fill="fillColor" />
          <rect height="48" width="1" x="24" :fill="fillColor" />
          <rect height="48" width="1" x="36" :fill="fillColor" />
        </g>
        <g id="frets" transform="translate(0,2)">
          <rect height="1" width="37" y="0" :fill="fillColor" />
          <rect height="1" width="37" y="12" :fill="fillColor" />
          <rect height="1" width="37" y="24" :fill="fillColor" />
          <rect height="1" width="37" y="36" :fill="fillColor" />
          <rect height="1" width="37" y="48" :fill="fillColor" />
        </g>
        <g id="closedStrings" class="closedStrings" transform="translate(1,13)">
          <g v-if="fret_list[0] > 0" :transform="return_translate_small(0)">
            <circle :fill="return_highlight(0)" r="4" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
          <g v-if="fret_list[1] > 0" :transform="return_translate_small(1)">
            <circle :fill="return_highlight(1)" r="4" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
          <g v-if="fret_list[2] > 0" :transform="return_translate_small(2)">
            <circle :fill="return_highlight(2)" r="4" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
          <g v-if="fret_list[3] > 0" :transform="return_translate_small(3)">
            <circle :fill="return_highlight(3)" r="4" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
        </g>
        <g id="openStrings" class="openStrings" transform="translate(1,-6)">
          <circle
            v-if="fret_list[0] == 0"
            :stroke="return_highlight(0)"
            :stroke-width="return_highlight_stroke(0)"
            cx="0"
            r="3"
            fill="none"
          />
          <circle
            v-if="fret_list[1] == 0"
            :stroke="return_highlight(1)"
            :stroke-width="return_highlight_stroke(1)"
            cx="12"
            r="3"
            fill="none"
          />
          <circle
            v-if="fret_list[2] == 0"
            :stroke="return_highlight(2)"
            :stroke-width="return_highlight_stroke(2)"
            cx="24"
            r="3"
            fill="none"
          />
          <circle
            v-if="fret_list[3] == 0"
            :stroke="return_highlight(3)"
            :stroke-width="return_highlight_stroke(3)"
            cx="36"
            r="3"
            fill="none"
          />
        </g>
        <g id="mutedStrings" transform="translate(1,-3)">
          <text v-if="fret_list[0] == 'muted'" x="0" text-anchor="middle">
            x
          </text>
          <text v-if="fret_list[1] == 'muted'" x="12" text-anchor="middle">
            x
          </text>
          <text v-if="fret_list[2] == 'muted'" x="24" text-anchor="middle">
            x
          </text>
          <text v-if="fret_list[3] == 'muted'" x="32" text-anchor="middle">
            x
          </text>
        </g>
        <g id="subText" transform="translate(1,98)">
          <text x="0" text-anchor="middle" />
          <text x="12" text-anchor="middle" />
          <text x="24" text-anchor="middle" />
          <text x="32" text-anchor="middle" />
        </g>
      </g>
    </svg>
    <svg
      v-if="!small"
      width="90"
      height="118"
      viewBox="0 0 90 118"
      style="font-family: sans-serif; font-size: 12px;"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <text
        x="38"
        y="14"
        text-anchor="middle"
        :style="'font-size: 16px; fill: ' + fillColor"
      >
        {{ chord }}
      </text>
      <g :transform="return_diagram_position()">
        <text id="position" x="69" y="17" text-anchor="left">
          {{ position }}
        </text>
        <rect
          v-if="position == 0"
          id="nut"
          height="4"
          width="62"
          :fill="fillColor"
        />
        <g id="diamond" style="visibility:hidden;">
          <rect
            width="14"
            height="14"
            transform="translate(0,-10),rotate(45)"
          />
        </g>
        <g id="strings" transform="translate(0,2)">
          <rect height="80" width="2" x="0" :fill="fillColor" />
          <rect height="80" width="2" x="20" :fill="fillColor" />
          <rect height="80" width="2" x="40" :fill="fillColor" />
          <rect height="80" width="2" x="60" :fill="fillColor" />
        </g>
        <g id="frets" transform="translate(0,2)">
          <rect height="2" width="62" y="0" :fill="fillColor" />
          <rect height="2" width="62" y="20" :fill="fillColor" />
          <rect height="2" width="62" y="40" :fill="fillColor" />
          <rect height="2" width="62" y="60" :fill="fillColor" />
          <rect height="2" width="62" y="80" :fill="fillColor" />
        </g>
        <g id="closedStrings" class="closedStrings" transform="translate(1,13)">
          <g v-if="fret_list[0] > 0" :transform="return_translate(0)">
            <circle :fill="return_highlight(0)" r="6" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
          <g v-if="fret_list[1] > 0" :transform="return_translate(1)">
            <circle :fill="return_highlight(1)" r="6" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
          <g v-if="fret_list[2] > 0" :transform="return_translate(2)">
            <circle :fill="return_highlight(2)" r="6" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
          <g v-if="fret_list[3] > 0" :transform="return_translate(3)">
            <circle :fill="return_highlight(3)" r="6" />
            <text fill="white" y="4" text-anchor="middle" />
          </g>
        </g>
        <g id="openStrings" class="openStrings" transform="translate(1,-6)">
          <circle
            v-if="fret_list[0] == 0"
            :stroke="return_highlight(0)"
            :stroke-width="return_highlight_stroke(0)"
            cx="0"
            r="4"
            fill="none"
          />
          <circle
            v-if="fret_list[1] == 0"
            :stroke="return_highlight(1)"
            :stroke-width="return_highlight_stroke(1)"
            cx="20"
            r="4"
            fill="none"
          />
          <circle
            v-if="fret_list[2] == 0"
            :stroke="return_highlight(2)"
            :stroke-width="return_highlight_stroke(2)"
            cx="40"
            r="4"
            fill="none"
          />
          <circle
            v-if="fret_list[3] == 0"
            :stroke="return_highlight(3)"
            :stroke-width="return_highlight_stroke(3)"
            cx="60"
            r="4"
            fill="none"
          />
        </g>
        <g id="mutedStrings" transform="translate(1,-3)">
          <text v-if="fret_list[0] == 'muted'" x="0" text-anchor="middle">
            x
          </text>
          <text v-if="fret_list[1] == 'muted'" x="20" text-anchor="middle">
            x
          </text>
          <text v-if="fret_list[2] == 'muted'" x="40" text-anchor="middle">
            x
          </text>
          <text v-if="fret_list[3] == 'muted'" x="60" text-anchor="middle">
            x
          </text>
        </g>
        <g id="subText" transform="translate(1,98)">
          <text x="0" text-anchor="middle" />
          <text x="20" text-anchor="middle" />
          <text x="40" text-anchor="middle" />
          <text x="60" text-anchor="middle" />
        </g>
      </g>
    </svg>
  </span>
</template>

<script>
import map from "lodash/map";
import isUndefined from "lodash/isUndefined";
import find from "lodash/find";
import max from "lodash/max";
import min from "lodash/min";

export default {
  props: {
    frets: { type: String, default: () => "" },
    chord: { type: String, default: () => "" },
    small: { type: Boolean, default: () => false },
    fillColor: { type: String, default: () => "black" },
    tuningOverride: { type: String, default: () => "" }
  },
  data: function() {
    return {
      position: "",
      highlight_list: [],
      fret_list: ""
    };
  },
  computed: {
    lookup_list() {
      if (this.tuningOverride == "C") {
        return this.$store.state.chord_list;
      }
      if (this.tuningOverride == "G") {
        return this.$store.getters.g_chord_list;
      }
      return this.$store.getters.active_chord_list;
    },
    ukeTuning() {
      return this.$store.getters.ukeTuning;
    }
  },
  watch: {
    ukeTuning() {
      this.set_fret_list();
    }
  },
  mounted: function() {
    this.set_fret_list();
  },
  methods: {
    set_fret_list: function() {
      var _fret_list;
      if (this.frets === "") {
        // Find in the chord diagrams via window.lookup_list.
        var _frets = find(this.lookup_list, { name: this.chord });
        if (isUndefined(_frets)) {
          _fret_list = [0, 0, 0, 0];
        } else {
          _fret_list = _frets.frets.split("-");
        }
      } else {
        // Check for highlights.
        _fret_list = this.frets.split("-");
        var _highlight_list = [];
        _fret_list = map(_fret_list, function(val, i) {
          if (val.includes("(")) {
            // Add to highlight_list and remove.
            _highlight_list.push(4 - i);
            var new_val = val.replace("(", "").replace(")", "");
            return new_val;
          } else {
            return val;
          }
        });
        this.highlight_list = _highlight_list;
      }
      _fret_list = map(_fret_list, function(i) {
        if (i == "x") {
          return "muted";
        } else {
          return parseInt(i, 10);
        }
      });
      var _v = this;
      if (max(_fret_list) > 4) {
        _v.position = min(_fret_list);
        _fret_list = map(_fret_list, function(i) {
          if (i == "muted") {
            return "muted";
          } else {
            return i - (_v.position - 1);
          }
        });
      }
      this.fret_list = _fret_list;
    },
    return_highlight: function(idx) {
      // If string is in highlight list, return highlight color.
      if (this.highlight_list.includes(4 - idx)) {
        return "red";
      }
      return this.fillColor;
    },
    return_highlight_stroke: function(idx) {
      // If string is in highlight list, return highlight color.
      if (this.highlight_list.includes(4 - idx)) {
        return 2;
      }
      return 0.6;
    },
    return_translate: function(idx) {
      var fret_position = this.fret_list[idx];
      if (fret_position == "muted") {
        // muted.
        return "translate(0, 0)";
      }
      return "translate(" + idx * 20 + ", " + (fret_position - 1) * 20 + ")";
    },
    return_translate_small: function(idx) {
      var fret_position = this.fret_list[idx];
      if (fret_position == "muted") {
        // muted.
        return "translate(0, 0)";
      }
      return (
        "translate(" + idx * 12 + ", " + ((fret_position - 1) * 12 - 4) + ")"
      );
    },
    return_diagram_position_small: function() {
      if (isUndefined(this.chord)) {
        return "translate(6, 9)";
      }
      return "translate(6, 28)";
    },
    return_diagram_position: function() {
      if (isUndefined(this.chord)) {
        return "translate(6, 12)";
      }
      return "translate(6, 32)";
    }
  }
};
</script>

<style lang="scss" scoped></style>
